import { createContext, useContext } from "react";

import { ClaimReviewHelper } from "./ClaimReviewHelper.ts";

export const ClaimReviewContext = createContext<ClaimReviewHelper>(
  {} as ClaimReviewHelper
);

export const useClaimReviewContext = () => useContext(ClaimReviewContext);
